import Stockroom from "../../pages/Stockroom";
import { InternalUserRoles } from "../../constants/roles";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalance";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/stockroom";

export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: Stockroom,
  allowedRoles: InternalUserRoles,
  label: "Stockroom",
  icon: () => <AccountBalanceOutlinedIcon fontSize="large" />,
  isCustomIcon: false,
  hasDivider: false,
};

export const stockroomRoutes: { [key: string]: RouteConfig } = {
  stockroom: baseRoute,
};
